import { FormControl } from '@angular/forms';

export const PhoneNumberPatter = /^(?!(\d)\1+$)(?:\(?\+\d{1,3}\)?[- ]?|0)?[\d\s]{9,11}$/;

export function PhoneNumberValidator(): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if (val && val !== null && val !== undefined) {
      const regex = RegExp(PhoneNumberPatter);

      if (!regex.test(val)) {
        return { invalidPhoneNumber: true };
      }
    }

    return null;
  };
}

export function TextValidator(maxLimit = 30): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if ((val && val !== null) || val !== undefined) {
       if (maxLimit === 4 && val && val.length > 4) {
        return { invalidTextMax4: true };
       } else if (maxLimit === 5 && val && val.length > 5) {
        return { invalidTextMax5: true };
       } else if (maxLimit === 20 && val && val.length > 20) {
        return { invalidTextMax20: true };
        } else if (maxLimit === 30 && val && val.length > 30) {
          return { invalidTextMax30: true };
        } else if (maxLimit === 50 && val && val.length > 50) {
          return { invalidTextMax50: true };
        } else if (maxLimit === 100 && val && val.length > 100) {
          return { invalidTextMax100: true };
        } else if (maxLimit === 200 && val && val.length > 200) {
          return { invalidTextMax200: true };
        } else if (maxLimit === 300 && val && val.length > 300) {
          return { invalidTextMax300: true };
        } else if (maxLimit === 500 && val && val.length > 500) {
          return { invalidTextMax500: true };
        } else if (maxLimit === 1000 && val && val.length > 1000) {
          return { invalidTextMax1000: true };
        } else if (maxLimit === 1500 && val && val.length > 1500) {
          return { invalidTextMax1500: true };
        } else if (maxLimit === 2000 && val && val.length > 2000) {
          return { invalidTextMax2000: true };
        } else if (maxLimit === 3000 && val && val.length > 3000) {
          return { invalidTextMax3000: true };
        } else if (maxLimit === 4000 && val && val.length > 4000) {
          return { invalidTextMax4000: true };
        }
       return null;
    }
  };
}

export function checkHTMLTags(): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if ((val && val !== null) || val !== undefined) {
      const regex = RegExp(`<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE|a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?>|<(video).*?</2>/i`);
      if (regex.test(val)) {
        return { htmlTagError: true };
      }
    }
    return null;
  };
}

export function SymbolValidator(): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if ((val && val !== null) || val !== undefined) {
      const regex = RegExp(`^[a-zA-Z0-9 ]*$`);
      if (!regex.test(val)) {
        return { invalidSpecialSymbol: true };
      }
    }
    return null;
  };
}

export function PercentageValidator(): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if ((val && val !== null) || val !== undefined) {
      const parseVal = parseFloat(val);
      if (val && parseVal > 100) {
        return { invalidPercentageRange: true };
      }
    }
    return null;
  };
}

export function NumberValidator(): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if ((val && val !== null) || val !== undefined) {
      const regex = RegExp(`^[(-9)-9]`);
      if (val && (!regex.test(val) || isNaN(val) || (val && val.toString() === '-0'))) {
        return { invalidNumber: true };
      }
    }
    return null;
  };
}

export function onlyNumberNotAllowValidator(): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if ((val && val !== null) || val !== undefined) {
      const regex = RegExp(`[(-9)-9]`);
      if (val && val.length && !isNaN(val)) {
        return { onlyNumberNotAllow: true };
      }
    }
    return null;
  };
}

export function PositiveNumberValidator(): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if ((val && val !== null) || val !== undefined) {
      const parseVal = parseFloat(val);
      if (val && (!RegExp(`^[(-9)-9]`).test(val) || isNaN(val) || (val && val.toString() === '-0'))) {
        return { invalidNumber: true };
      } else if (val && parseVal < 0) {
        return { invalidNegativeNumber: true };
      }
    }
    return null;
  };
}

export function NumberRangeBtn2number(num1, num2): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if ((val && val !== null)) {
      const parseVal = parseFloat(val);
      if (num1 === 1 && num2 === 10 && !(parseVal >= num1 && parseVal <= num2)) {
        return {numberAllowRatioBtn1to10: true};
      } else if (num1 === 0 && num2 === 10 && !(parseVal >= num1 && parseVal <= num2)) {
        return {numberAllowRatioBtn0to10: true};
      }
    }
    return null;
  };
}

export function IntegerValidator(maxLimit?): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if ((val && val !== null) && val !== undefined) {
      const regex = RegExp(/^\d*$/);
      if (val && !regex.test(val) || isNaN(val)) {
        return { invalidInteger: true };
      } else if (maxLimit === 2147483647 && val > 2147483647) {
        return {invalidNumber2147483647: true};
      }
    }
    return null;
  };
}

export function NumberRangeValidator(maxLimit = 100): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    if ((val && val !== null) || val !== undefined) {
      const parseVal = parseFloat(val);
      if ((val && isNaN(val)) || (val && val.toString() === '-0')) {
        return { invalidNumber: true };
      } else if (maxLimit === 100 && parseVal > 100) {
        return { invalidNumber100: true };
      } else if (maxLimit === 99999 && parseVal > 99999) {
        return { invalidNumber99999: true };
      } else if (maxLimit === 999999 && parseVal > 999999) {
        return {invalidNumber999999: true };
      } else if (maxLimit === 9999999 && parseVal > 9999999) {
        return {invalidNumber9999999: true };
      } else if (maxLimit === -9999999 && parseVal < -9999999) {
        return {invalidNegativeNumber9999999: true };
      } else if (maxLimit === 99999999 && parseVal > 99999999) {
        return {invalidNumber99999999: true };
      } else if (maxLimit === -99999999 && parseVal < -99999999) {
        return {invalidNegativeNumber99999999: true };
      } else if (maxLimit === 999999999 && parseVal > 999999999) {
        return {invalidNumber999999999: true };
      } else if (maxLimit === -999999999 && parseVal < -999999999) {
        return {invalidNegativeNumber999999999: true };
      } else if (maxLimit === 9999999999 && parseVal > 9999999999) {
        return {invalidNumber9999999999: true };
      } else if (maxLimit === -9999999999 && parseVal < -9999999999) {
        return {invalidNegativeNumber9999999999: true };
      } else if (maxLimit === 999 && parseVal > 999) {
        return { invalidNumber999: true };
      } else if (maxLimit === 9999 && parseVal > 9999){
          return { invalidNumber9999: true };
      }else if (maxLimit === 2147483647 && parseVal > 2147483647) {
        return {invalidNumber2147483647: true};
      }
    }
    return null;
  };
}

export function NumberDecimalValidator(maxLimit = 6): any {
  return (control: FormControl): { [key: string]: any } => {
    maxLimit = new Number(maxLimit).valueOf();
    const val = control.value;
    if ((val && val !== null) || val !== undefined) {
      const parseVal = parseFloat(val);
      let decimals: string;
      let beforeDecimal;
      let afterDecimal;
      if (val && val.toString().split('.').length) {
        decimals = val.toString().split('.')[1];
        beforeDecimal = val.toString().split('.')[0];
        afterDecimal = val.toString().split('.')[1];
      }
      if ((val && isNaN(val)) ||
      (val && val.toString() === '-0') ||
       //(beforeDecimal == '' && beforeDecimal.length == 0) ||
       (afterDecimal == '' && afterDecimal.length == 0)
       ) {
        return { invalidNumber: true };
      } else if (maxLimit === 0 && decimals && decimals.length > 0) {
        return { invalidDeciamlNumber0: true };
      } else if (maxLimit === 1 && decimals && decimals.length > 1) {
        return { invalidDeciamlNumber1: true };
      } else if (maxLimit === 2 && decimals && decimals.length > 2) {
        return { invalidDeciamlNumber2: true };
      } else if (maxLimit === 3 && decimals && decimals.length > 3) {
        return { invalidDeciamlNumber3: true };
      } else if (maxLimit === 4 && decimals && decimals.length > 4) {
        return { invalidDeciamlNumber4: true };
      } else if (maxLimit === 5 && decimals && decimals.length > 5) {
        return { invalidDeciamlNumber5: true };
      } else if (maxLimit === 6 && decimals && decimals.length > 6) {
        return { invalidDeciamlNumber6: true };
      }
    }
    return null;
  };
}
